import React from 'react';

import '../BaseLayout/BaseLayout.scss';
import './Vertical.scss';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { toggleSidebar } from '../../redux/settings/actions';
import BaseLayout from '../BaseLayout/BaseLayout';
import Navbar from '../components/Navbar/Navbar';
import Menu from '../components/Menu/Menu';
import Logo from '../components/Logo/Logo';
import Footer from '../components/Footer/Foooter';
import Actions from '../components/Actions/Actions';
import NavbarSkeleton from '../components/NavbarSkeleton/NavbarSkeleton';
import { IPageData } from '../../interfaces/page-data';
import { IAppSettings } from '../../interfaces/settings';
import { AppState } from '../../redux/store';
import BasePage from '../../pages/BasePage/BasePage';
import { defaultRoutes } from '../../routes';
import { resetPageData, setPageData } from '../../redux/pages/actions';
import { Toaster } from 'react-hot-toast';

const getGradientString = (firstColor: string, secondColor: string): string =>
  `linear-gradient(188deg, ${firstColor} 30%, ${secondColor} 100%)`;

interface VerticalLayoutProps {
  pageData: IPageData;
  settings: IAppSettings;
  onSidebarToggle: () => void;
  onSettingsReset: () => void;
  onSettingsSet: (data: IAppSettings) => void;
  onSettingsUpdate: (data: IAppSettings) => void;
  onSetPage: (data: IPageData) => void;
  onPageReset: () => void;
}

const VerticalLayout: React.FunctionComponent<VerticalLayoutProps> = (props) => {


  const { pageData, settings, onSidebarToggle, onPageReset, onSetPage } = props;
  const {
    sidebarColor,
    topbarColor,
    topbarBg,
    sidebarOpened,
    //layout,
    boxed,
  } = settings;

  
  //const [menuData, setMenuData] = useState<IMenuItem[]>([]);
  const menuData = [
    {
        title: 'Gösterge Paneli',
        icon:{
            class: 'icofont-home',
        },
        routing: 'dashboard',
        role: [0, 1, 2],
    },
    {
        title: 'Kullanıcı Listesi',
        icon: {
            class: 'icofont-home',
        },
        routing: 'user-list',
        role: [1, 2],
    },
    {
        title: 'Şirket Listesi',
        icon: {
            class: 'icofont-home',
        },
        routing: 'company-list',
        role: [1, 2],
    },
    {
        title: 'Ayarlar',
        icon: {
            class: 'icofont-home',
        },
        routing: 'settings',
        role: [2],
    }
  ];
  // const [settingsVisibility, setSettingsVisibility] = useState(false);
  const routes = defaultRoutes;

  /*useEffect(() => {
    async function fetchData() {
      const result = await axios({baseURL: '', url: './data/menu.json', method: 'get'});
      setMenuData(result.data);
    }

    fetchData().catch(err => console.log('Server Error', err));
  }, []);*/

  const handleToggleSidebar = () => {
    onSidebarToggle();
  };

  // const handleSettingsModalClose = () => {
  //   setSettingsVisibility(false);
  // };

  // const handleSettingsClick = () => setSettingsVisibility(true);

  return (
    <div className='layout vertical'>
      <div className={`app-container ${boxed && 'boxed'}`}>
        <Navbar
          style={{ backgroundImage: getGradientString('#99cc99', '#6666cc') }}
          orientation='vertical'
          opened={sidebarOpened}
          onCloseNavbar={handleToggleSidebar}>
          <button
            className='no-style navbar-close icofont-close-line d-lg-none'
            onClick={onSidebarToggle}
          />
          <Logo style={{ backgroundColor: topbarBg }} height={33} width={147} />
          <Menu
            color={sidebarColor}
            accentContrast={'#333399'}
            accentColor={'#e2ffe2'}
            data={menuData}
            layout={'vertical'}
          />
          <NavbarSkeleton type='vertical' loaded={true} />
        </Navbar>

        <Navbar
          boxed={boxed}
          style={{ backgroundColor: topbarBg, color: topbarColor }}
          orientation='horizontal'
          className='horizontal-nav'
          minHeight={60}>
          <button className='navbar-toggle d-lg-none' onClick={handleToggleSidebar}>
            <span />
            <span />
            <span />
          </button>

          <Actions />

          <NavbarSkeleton type='horizontal' loaded={true} />
        </Navbar>

        <Toaster
          position='top-right'
          toastOptions={{
            style: {
              width: '280px',
              height: '50px',
              fontSize: '14px',
              color: 'white',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#65CC6D',
                secondary: 'white',
              },
              style: {
                background: '#65CC6D',
              },
            },
            error: {
              iconTheme: {
                primary: '#FF6961',
                secondary: 'white',
              },
              duration: 3000,
              style: {
                background: '#FF6961',
              },
            },
            custom: {
              iconTheme: {
                primary: '#FFA500',
                secondary: 'white',
              },
              duration: 3000,
              style: {
                background: '#FFA500',
              },
            },
          }}
        />

        <BaseLayout
          pageData={pageData}
          settings={settings}
          onPageReset={onPageReset}
          onSidebarToggle={onSidebarToggle}>
          {routes.map((route, i) => {
            return (
              <Route
                exact
                key={i}
                path={`/vertical${route.path}`}
                render={() => (
                  <BasePage>
                    <route.component onSetPage={onSetPage} />
                  </BasePage>
                )}
              />
            );
          })}
        </BaseLayout>

        <Footer boxed={boxed} loaded={true} />

        {/* <button className='no-style settings-btn' onClick={handleSettingsClick}>
          <span className='pulse' />
          <span className='icofont-bucket2' />
        </button> */}
      </div>

      {/* <Settings opened={settingsVisibility} onClose={handleSettingsModalClose} /> */}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  pageData: state.pageData,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  onSidebarToggle: () => dispatch(toggleSidebar()),
  onSetPage: (data: IPageData) => dispatch(setPageData(data)),
  onPageReset: () => dispatch(resetPageData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerticalLayout);
